/**
 * Counters reach the evaluator at most once per this many minutes: the rate is taken
 * over a five-minute floor (`kairosdb::COUNTER_POLL_FLOOR_SECONDS`).
 */
export const COUNTER_MINUTES_PER_READING = 5;

/**
 * Why a window cannot work, or null. A time window has to hold the readings it asks
 * for, and four seeded alerts once asked for more than theirs could hold — they never
 * fired. Only a rated counter has a known floor; a gauge's cadence is the collector's.
 */
export function windowProblem(w: {
  windowType: string;
  windowMinutes: string;
  sustainedMinDatapoints: string;
  mOfNm: string;
  mOfNn: string;
  checksX: string;
  checksY: string;
  conditionTransform: string;
}): string | null {
  const int = (v: string) => Number.parseInt(v, 10);
  if (w.windowType === 'checks') {
    const x = int(w.checksX);
    const y = int(w.checksY);
    if (!(x >= 1 && y >= 1)) return 'Both numbers of checks must be at least 1.';
    if (x > y) return `${String(x)} of the last ${String(y)} checks can never happen: the first number cannot be larger.`;
    return null;
  }
  const rated = w.conditionTransform === 'rate_per_second' || w.conditionTransform === 'bits_per_second';
  const needed = w.windowType === 'sustained' ? int(w.sustainedMinDatapoints) : w.windowType === 'm_of_n' ? int(w.mOfNm) : 1;
  const minutes = int(w.windowMinutes);
  if (!rated || !(minutes > 0)) return null;
  const holds = Math.floor(minutes / COUNTER_MINUTES_PER_READING);
  if (needed > holds) {
    return `A ${String(minutes)}-minute window holds at most ${String(holds)} reading${holds === 1 ? '' : 's'} of a counter, which is read at most once every ${String(COUNTER_MINUTES_PER_READING)} minutes, so asking for ${String(needed)} can never fire. Count checks instead, ask for fewer, or widen the window.`;
  }
  return null;
}
